import moment from "moment";
import Arith from "../../utils/arith";

const getters = {
  roomNumDesc(state) {
    // console.log("roomNumDesc === ", state.roomNum);
    // ${
    //   state.childNum
    // }儿童
    return `${state.roomNum || 1}间房·${state.adultNum}成人`;
  },
  // 房间 {1: [empId1], 2: [empId2, ...]}
  roomEmpMap: (state) => {
    let rs = state.rooms;
    let roomEmpMap = {};
    (rs || []).forEach((room, roomIdx) => {
      let roomNo = roomIdx + 1;
      if (!roomEmpMap[roomNo]) roomEmpMap[roomNo] = [];
      room.forEach((emp) => {
        if (!!emp && emp.empId) {
          roomEmpMap[roomNo].push(emp.empId);
        }
      });
    });
    return roomEmpMap;
  },
  // 预订的间夜
  nightlyRates(state) {
    let ratePlan = state.selectRatePlan || {};
    return (ratePlan.nightlyRates || []).map((item) => {
      // 房间
      item.roomSalePrice = Arith.mul(item.salePrice, state.rooms.length);
      let jdjgbz = state.htCnPolicy?.policy?.jdjgbz || 0;
      item.isCb = jdjgbz < item.salePrice;
      return item;
    });
  },
  // 下单时预定的间夜数
  nightCount(state) {
    const yFormat = "YYYY-MM-DD";
    let start = moment(state.htCnParams.checkInDate, yFormat);
    let end = moment(state.htCnParams.checkOutDate, yFormat);
    return end.diff(start, "day");
  },
  // 下单时的超标金额
  fillCbje(state, getters, _, action) {
    let jy = getters.nightCount * state.rooms.length;
    let jdjgbz = state.htCnPolicy?.policy?.jdjgbz || 0;
    // 差标总金额
    let price = Arith.mul(jdjgbz, jy);
    let cb = 0;
    let nightlyRates = getters.nightlyRates || [];
    let getVipParamterByParNo = action["common/getVipParamterByParNo"];
    // 酒店是否开启单间夜价格二次匹配差标
    let ht20076 = getVipParamterByParNo(20076, 0);
    if (ht20076) {
      nightlyRates.forEach((item) => {
        let diff = Arith.sub(item.salePrice, jdjgbz);
        if (diff > 0) {
          cb += diff;
        }
      });
    } else {
      cb = Arith.sub(getters.getPriceDetail.totalRoomPrice, price);
    }
    console.log("fillCbje === ", cb);
    return cb;
  },
  // 国际酒店下单价格详情
  getPriceDetail(state, getters) {
    let result = {
      fee: 0, //服务费
      totalRoomPrice: 0, //房费总价
    };
    let nightlyRates = getters.nightlyRates || [];
    let serviceFee = {
      sellServiceCharge: state.selectRatePlan.serviceFee || 0,
      chargeunit: state.selectRatePlan.chargeunit,
    };
    
    if (nightlyRates.length) {
      for (var i = 0; i < nightlyRates.length; i++) {
        // 按间夜计算 服务费 = 价格 * 间夜数(晚数 * 房间数)
        if (serviceFee.chargeunit == 1) {
          let sellServiceCharge = Arith.mul(
            serviceFee.sellServiceCharge,
            state.rooms.length
          );
          result.fee = Arith.add(result.fee, sellServiceCharge);
        }
        let priceAfterTax = Arith.mul(
          nightlyRates[i].salePrice,
          state.rooms.length
        );
        result.totalRoomPrice = Arith.add(result.totalRoomPrice, priceAfterTax);
      }
    }
    // 按单计算
    if (serviceFee.chargeunit != 1) {
      result.fee = Arith.add(result.fee, serviceFee.sellServiceCharge);
    }
    //价格合计
    let price = Arith.add(result.fee, result.totalRoomPrice);
    result.totalPrice = price;
    console.log('getPriceDetail === ', result);
    return result;
  },
  getUseNameclbz(state, getters) {
    let minEmp = null;
    let policy = state.htCnPolicy.policy || {};
    let passagerTravelPolicies = policy.passagerTravelPolicies || [];
    for (let i = 0; i < passagerTravelPolicies.length; i++) {
      const item = passagerTravelPolicies[i];
      if (item.jdjgbz == policy.jdjgbz) {
        minEmp = item;
        break;
      }
    }
    if (minEmp) {
      return minEmp.empName
    }
    return '-';
  },
};

export default getters;
